import { FaXmark } from 'react-icons/fa6';
import { ActiveFilterProps } from './types';

export function ActiveFilter({ item, onRemove }: ActiveFilterProps) {
  return (
    <span
      key={item.id}
      className="flex flex-shrink-0 items-center gap-2 px-4 h-[33px] rounded-md bg-brand-primary text-black text-[0.9rem] font-bold"
    >
      <span>{item.label}</span>
      <span>
        <FaXmark className="cursor-pointer" onClick={() => onRemove(item.id)} />
      </span>
    </span>
  );
}
